/**
 * @Desription: 登录-提交
 * @Author: netstar.sjj
 * @Date: 2021-10-26 10:05:00
 * @class submit
*/
import strongLogin from './strong-login';//强制登录
import passwordExpire from './password-expire';//密码超期
declare const window:any;
export default function(paramsObj?:any) {
    //强制登录
    const strongLoginFunc:Function = strongLogin;
    //初次登录密码，密码超期
    const passwordExpiredFunc:Function = passwordExpire;
    //登录成功
    const successFunc:Function = function(res:any){
        let config:any = window.NSLogin.config;
        if(typeof(res.data.properties)=='object'){
            res.data.properties.context.envType = res.data.envType;
            window.store.set('loginProperty',res.data.properties);//登录成功之后获取系统用户信息
        }
        window.NSLogin.loginManger.remember.set();
        //保存授权码
        window.NSLogin.serverData = res;
        window.NSLogin.Authorization = res.data.token;
        window.NSUtils.OAuthCode.set({
            authorization:      res.data.token, 
            expireMinute:       config.expireMinute,
            loginTimeStamp:     new Date().getTime(),
        });
        if(typeof(config.loginAjax.beforeHandler) == "function"){
            config.loginAjax.beforeHandler(config,ajaxData);
        }else{
            window.NSLogin.toHomePage(res.data.token);
        }
    }
    //登录失败
    const failFunc:Function = function(res:any){
        window.store.remove("userInfo")//清空缓存信息
        let config:any = window.NSLogin.config;
        let msgStr:string = res.data.msg ? res.data.msg : res.msg;
        window.jQuery(config.msgEl).html(msgStr);
        window.jQuery(config.msgEl).removeClass('hide');
        let verificationCode:boolean = res.data.loginStatus == 4 ? true : false;//登录状态为4，需要验证码
        if(verificationCode === true){
            window.jQuery(config.verificationHidden).removeClass('hide');
        }
        let userNameVal:string = window.jQuery(config.usernameEl).val();
        let orgNameVal:string = window.jQuery(config.orgnameEl).val();
        let orgName:string = encodeURIComponent(orgNameVal);
        let userName:string = encodeURIComponent(userNameVal);
        let random:number = Math.random() * 100;
        let verificationImgUrl:string = window.NSUtils.getAPIUrl() + '/verificationCode?'+ "orgName=" + orgName +"&"+ "username=" +userName+"&random="+random;
        let htmlImg:string ='<img class="verification-img-size" src="'+ verificationImgUrl+'"><br/><a href="javascript:void(0);" id="refreshVerificationImg">'+window.language.login.verifiyName+'</a>';
        window.jQuery(config.verificationImgEl).html(htmlImg);
        window.jQuery('#refreshVerificationImg').off('click').on('click',window.NSLogin.loginManger.refreshVerImg);
        config.$login.removeClass('login-loading');
    }
    let config:any = window.NSLogin.config;
    let username:string = window.jQuery(config.usernameEl).val();
    let password:string = window.jQuery(config.passwordEl).val();
    let verificationCode:string = window.jQuery(config.verificationCodeEl).val();
    if(username == ''){
        window.jQuery(config.msgEl).html(window.language.login.username);
        window.jQuery(config.msgEl).removeClass('hide');
        config.$login.removeClass('login-loading');
        return;
    }
    if(password == ''){
        window.jQuery(config.msgEl).html(window.language.login.pwd);
        window.jQuery(config.msgEl).removeClass('hide');
        config.$login.removeClass('login-loading');
        return;
    }
    if(window.NetstarApiConfig.rememberUser&&window.NSUtils.getBrowserVersion().browserSystem!=="pc"&&window.cordova){
        window.store.set("userInfo",{userName:username,password:password,orgName:window.jQuery(config.orgnameEl).val()})//设置缓存信息
    }
    let passwordIsMD5:boolean = true;
    if(window.NetstarApiConfig.login){
        if(window.NetstarApiConfig.login.passwordIsMD5 == false){
            passwordIsMD5 = false;
        }
    }
    if(passwordIsMD5 === true){
        password = window.hex_md5(password);
    }
    let ajaxData:any = {
        login: 1,
        username: username,
        password: password,
        verificationCode: verificationCode,
        withProperties:1
    };     
    if(config.version === "v4"){
        delete ajaxData.withProperties;
    }
    if(!window.jQuery.isEmptyObject(paramsObj)){
        for(let pushParamI in paramsObj){
            ajaxData[pushParamI] = paramsObj[pushParamI];
        }
    }
    if(config.orgnameEl){
        ajaxData.orgName = window.jQuery(config.orgnameEl).val();
    }
    if(window.NetstarApiConfig.login){
        if(window.NetstarApiConfig.login.orgnameEl === false){
            if(typeof(ajaxData.orgName) != 'undefined'){
                delete ajaxData.orgName
            }
        }
    }
    
    let urlParams:any = window.NSUtils.getUrlPara();
    if(typeof(urlParams)=='object'){
        window.jQuery.each(urlParams, function(key:string,value:any){
            switch(key){
                case 'callback':
                    //callback是一个json文本 需要decode 例如 %257B%2522customerId%2522:1310336379963573234%257D  => {"customerId":1310336379963573234}
                    ajaxData[key] = decodeURIComponent(value);
                    break;
                default:
                    break;
            }
        });
    }
    if(typeof(config.loginAjax.handler)=='function'){
        config.loginAjax.handler(config,ajaxData);
        config.$login.removeClass('login-loading');
        return;
    }
    let contentTypeStr:string = 'application/x-www-form-urlencoded';//sjj 定义contentType
    if(config.loginAjax.contentType){
        contentTypeStr = config.loginAjax.contentType;
    }
    if(contentTypeStr == 'application/json'){
        contentTypeStr = 'application/json; charset=utf-8';
    }
    let methodStr:string = config.loginAjax.method ? config.loginAjax.method : 'GET';
    if(config.loginAjax.type){
        methodStr = config.loginAjax.type;
    }
    if(contentTypeStr == 'application/json; charset=utf-8'){
        ajaxData = JSON.stringify(ajaxData);
    }
    if(config.appName === 'hysw'){
        config.loginAjax.url += '?token='+username;
    }



    let ajaxConfig:any = {
        type: methodStr,
        dataType: 'json',
        url: config.loginAjax.url,  
        data: ajaxData,
        contentType:contentTypeStr,
        success: function (res:any) {
            res = typeof(res)=='object' ? res : {};
            let resData:any = typeof(res.data)=='object' ? res.data : {};
            if(res.success === true){
                resData.success = true;
            }
            if(resData.loginStatus === 8){
                strongLoginFunc();//强制登录
            }else if(resData.loginStatus === 2){
                passwordExpiredFunc();//密码超期
            }else{
                if(resData.success === true){
                    successFunc(res);//登录成功
                }else{
                    failFunc(res);//登录失败
                }
            }
        },
        error:window.NSLogin.ajaxError
    };
    if(!window.jQuery.isEmptyObject(config.loginAjax.headers)){
        ajaxConfig.headers = config.loginAjax.headers;
    }
    window.jQuery.ajax(ajaxConfig);
};